import React from 'react';
import { useTranslation } from 'react-i18next';
import './TooltipLabel.css';

/**
 * TooltipLabel Component
 *
 * Displays text in Malay (primary) with English tooltip on hover
 *
 * Usage:
 *
 * 1. Simple label with automatic English tooltip:
 *    <TooltipLabel tKey="common:label.district" />
 *
 * 2. Custom HTML element (default is span):
 *    <TooltipLabel tKey="common:label.school" as="label" />
 *
 * 3. With additional props (className, htmlFor, etc.):
 *    <TooltipLabel
 *      tKey="common:label.email"
 *      as="label"
 *      htmlFor="email-input"
 *      className="form-label required"
 *    />
 *
 * 4. Button with tooltip:
 *    <TooltipLabel
 *      tKey="common:button.save"
 *      as="button"
 *      onClick={handleSave}
 *      className="btn btn-primary"
 *    />
 */
const TooltipLabel = ({
  tKey,
  as: Component = 'span',
  className = '',
  children,
  ...props
}) => {
  const { t } = useTranslation();

  // Get Malay text and English tooltip
  const malayText = t(tKey, { lng: 'ms' });
  const englishTooltip = t(tKey, { lng: 'en' });

  return (
    <Component
      className={`tooltip-label ${className}`}
      title={englishTooltip}
      data-tooltip={englishTooltip}
      {...props}
    >
      {children || malayText}
    </Component>
  );
};

export default TooltipLabel;
